// extracted by mini-css-extract-plugin
export default {"overlay":"rw-z","bodyOpen":"sw-z","content":"tw-z","header":"uw-z","close":"vw-z","closeNoHeading":"ww-z"};